import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Permiso } from 'src/app/interfaces/permisos';
import { Usr } from 'src/app/interfaces/usr';
import { Vehiculo } from 'src/app/interfaces/vehiculo';
import { AppService } from 'src/app/service/app.service';
import { PermisoService } from 'src/app/service/permiso.service';
import { UsuarioService } from 'src/app/service/usuario.service';
import { VehiculoService } from 'src/app/service/vehiculo.service';

@Component({
  selector: 'app-usuario-form',
  templateUrl: './usuario-form.component.html',
  styleUrls: ['./usuario-form.component.css']
})
export class UsuarioFormComponent implements OnInit {
  public usuario:Usr;
  public vehiculos?:Vehiculo[];
  public permisos?:any[];
  public appsUsuario:any[];
  public apps:any[];
  public idApp;
  constructor( @Inject(MAT_DIALOG_DATA) public data: any, private usuarioService:UsuarioService, private vehiculoService:VehiculoService, private permisoService:PermisoService, private appService:AppService) {
    this.appsUsuario=new Array<any>();
    this.apps=new Array<any>();
    this.idApp=0;
    this.usuario={
      id:0,
      nombre:'',
      email:'',
      password:'',
      estado:true,
      id_vehiculo:0
    };
    this.vehiculoService.getVehiculos().subscribe((vehiculo:Vehiculo[])=>{
      this.vehiculos=vehiculo;
    });
    this.appService.get().subscribe((app:any[])=>{
      this.apps=app;
    })
    if(data.id>0){
      this.usuarioService.getById(data.id).subscribe((usr:any)=> {
        this.usuario=usr;
        console.log(usr.token)
        this.permisoService.getbyid(usr.id).subscribe((item:Permiso[])=>{
          this.permisos=item;
          this.permisos.forEach(element => {
            let algo=this.apps.filter(app=> app.id === element.id_app)[0];
            this.appsUsuario?.push({id:element.id ,id_app:algo.id, id_usuario:data.id, appNombre:algo.descripcion, estado:true});
            });
        });
      });

    }
  }

  ngOnInit(): void {

  }
  quitarPermiso(id: number){
    let index=this.appsUsuario.findIndex(app => app.id_app===id)
    let app=this.appsUsuario[index];
    if(app.id===0){
      this.appsUsuario.splice(index,1);

    }else {
      let item =this.appsUsuario[index];
      item.estado=false


    }
  }
  agregarPermiso(){

    let app = this.apps.find(algo => algo.id.toString() === this.idApp);
    this.appsUsuario?.push({id:0, id_app:app.id, id_usuario:this.data.id, appNombre:app.descripcion, estado:true})
  }
  guardar(){
    if(this.usuario.id===0){
      this.usuarioService.post(this.usuario,this.appsUsuario)
    }else{
      this.usuarioService.put(this.usuario,this.appsUsuario)
    }
  }
}
